import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-information',
  templateUrl: './popup-information.component.html',
  styleUrls: ['./popup-information.component.scss']
})
export class PopupInformationComponent implements OnInit {

  isVisible = true;

  constructor() { }

  ngOnInit(): void {
  }

  closeModal() {
    this.isVisible = false;
  }

}
